export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // hertz grey,
  MAIN_COLOR: '#000000', // hertz black
  MAIN_INVERTED_COLOR: '#000000', // white
  PRIMARY_COLOR: '#ffcc00', // hertz yellow
  SECONDARY_COLOR: '#434244', // hertz dark grey
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
